import { RootState } from 'store/root-reducer';
import { Connectors } from '../types';

export const getConnectors = (state: RootState): Connectors | null => state.system.connectors.connectors;

export const isLoading = (state: RootState): boolean => state.system.connectors.isLoading;

export const isUpdatedConnectorLoading = (state: RootState): boolean =>
  state.system.connectors.isUpdatedConnectorLoading;
